import type {
  WalletCheckDelegationRequestBody,
  WalletCheckDelegationResponseBody,
} from 'uniswap/src/data/tradingApi/__generated__'
import type {
  ChainDelegationDetails,
  DelegationRepository,
} from 'uniswap/src/features/smartWallet/delegation/delegationRepository'
import type { Logger } from 'utilities/src/logger/logger'

interface TradingApiClient {
  checkWalletDelegation: (params: WalletCheckDelegationRequestBody) => Promise<WalletCheckDelegationResponseBody>
}

export function createTradingApiDelegationRepository(ctx: {
  tradingApiClient: TradingApiClient
  logger?: Logger
}): DelegationRepository {
  const getWalletDelegations: DelegationRepository['getWalletDelegations'] = async (input) => {
    const result: ChainDelegationDetails = {}
    try {
      const response = await ctx.tradingApiClient.checkWalletDelegation({
        walletAddresses: [input.address],
        chainIds: input.chainIds,
      })
      const walletDelegationDetails = response.delegationDetails[input.address]

      for (const chainId of input.chainIds) {
        const details = walletDelegationDetails?.[chainId]
        result[String(chainId)] = details
          ? {
              currentDelegationAddress: details.currentDelegationAddress,
              isWalletDelegatedToUniswap: details.isWalletDelegatedToUniswap,
              latestDelegationAddress: details.latestDelegationAddress,
            }
          : null
      }
    } catch (error) {
      ctx.logger?.error(error, {
        tags: { file: 'createTradingApiDelegationRepository.ts', function: 'getWalletDelegations' },
        extra: { address: input.address, chainIds: input.chainIds },
      })
      for (const chainId of input.chainIds) {
        result[String(chainId)] = null
      }
    }
    return result
  }

  return { getWalletDelegations }
}
